∏
<template>
  <div>
    <el-row style="height: 30px; border-bottom: 1px solid #ddd">
      <el-col :span="24"> 商品库存详情 </el-col>
    </el-row>

    <el-row>
      <el-col>
        <div class="card-title">基本信息</div>
        <el-table :data="[base_detail]" border style="width: 100%">
          <el-table-column prop="origin" label="仓库" align="center">
          </el-table-column>
          <el-table-column prop="where_text" label="仓区" align="center">
          </el-table-column>
          <el-table-column prop="stockNum" label="库存" align="center">
          </el-table-column>
          <el-table-column prop="priceSum" label="库存金额" align="center">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-row style="border: 1px solid #ddd">
      <el-col :span="24">
        <el-row
          style="
            background: #f3f3f3;
            height: 30px;
            line-hei商品信息ght: 30px;
            padding: 0 25px;
          "
        >
          <el-col :span="24"> 商品信息 </el-col>
        </el-row>
        <el-row v-if="stock_detail">
          <el-col :span="24">
            <el-table :data="stock_detail" border style="width: 100%">
              <el-table-column prop="goods_img" label="商品图片" align="center">
                <template slot-scope="scope">
                  <div
                    v-viewer
                    style="
                      width: 40px;
                      height: 40px;
                      overflow: hidden;
                      cursor: pointer;
                      margin: auto;
                    "
                  >
                    <img
                      style="width: 100%; height: 100%"
                      :src="scope.row.goods_img"
                    />
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="goods_no" label="商品货号" align="center">
              </el-table-column>
              <el-table-column
                prop="goods_name"
                label="商品名称"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="co_val" label="颜色" align="center">
              </el-table-column>
              <el-table-column prop="si_val" label="尺码" align="center">
              </el-table-column>
              <el-table-column prop="dbid" label="打标id" align="center">
              </el-table-column>
              <el-table-column
                prop="sj_status_text"
                label="上架状态"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="space" label="仓位" align="center">
              </el-table-column>
              <el-table-column prop="price" label="代采价" align="center">
              </el-table-column>
              <el-table-column
                prop="stock_in_record_type"
                label="入库方式"
                align="center"
              >
              </el-table-column>
              <!-- <el-table-column prop="market_name" label="市场/子市场" align="center">
              </el-table-column> -->
              <!-- <el-table-column prop="brand_name" label="品牌" align="center">
              </el-table-column> -->
              <!-- <el-table-column prop="supply_name" label="商家" align="center">
              </el-table-column> -->
              <el-table-column
                prop="create_time"
                label="入库时间"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="where_text"
                label="当前仓区"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="admin_name" label="操作人" align="center">
              </el-table-column>
              <!-- <el-table-column prop="stock_total_num" label="库存" align="center">
              </el-table-column>
              <el-table-column prop="stock_total_price" label="库存金额" align="center">
              </el-table-column> -->
            </el-table>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 单据信息等 -->
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      stock_detail: null,
      base_detail: null,
      textarea: "",
      url: "/erp/StockInRecord/stockDetail",
    };
  },
  methods: {
    fetchData() {
      let args = {
        goods_no: this.$route.params.id,
        co_id: this.$route.query.co_id,
        where: this.$route.query.where,
        si_id: this.$route.query.si_id,
      };
      this.$http.post(this.url, args).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.stock_detail = res.data.data.stock_detail;
          this.base_detail = res.data.data.base_detail;
        }
      });
    },
    reject() {
      let args = {
        refund_id: this.$route.params.id,
      };
      this.$http.post(this.url, args).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$notify({
            title: "操作成功",
            message: "已驳回该代采订单",
            type: "success",
          });
        }
      });
    },
  },
};
</script>

<style>
.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.card-title {
  background: #f3f3f3;
  height: 30px;
  line-height: 30px;
  padding: 0 25px;
}

.viewer {
  border: 1px solid #ddd;
  overflow: scroll;
  height: 398px;
}

.btn-operation {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/StockDetail.vue